// Clinic Configuration for Dentist In Concord
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Centennial",
  clinicId: "dentistincentennial",
  clinicUrl: "https://www.dentistincentennial.com",

  // Contact Information
  phoneNumber: "3039239068",
  phoneNumberRaw: "+13039239068", // For tel: and sms: links
  email: "Dentalcare@dentistincentennial.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistincentennial&agentId=6e5094e2-f3f3-4e7d-a2f2-6122fc2dc61e",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistincentennial/voice",

  // Location
  address: "20269 E Smoky Hill Rd, Centennial, CO 80015, United States",
  addressShort: "20269 E Smoky Hill Rd, Centennial, CO 80015, USA",
  city: "Centennial",
  hcity: "Centennial",
  state: "Colorado",
  stateShortForm: "CO",
  PostalCode: "80015",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/87p9A3EL9sJeds4w9",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11686.398382346639!2d-104.751476!3d39.61182600000001!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c8bfe1acb5263%3A0x3761f673e0247379!2s20269%20E%20Smoky%20Hill%20Rd%20H%2C%20Centennial%2C%20CO%2080015%2C%20USA!5e1!3m2!1sen!2sin!4v1756793831141!5m2!1sen!2sin',
  iframeTitle: "Dentist In Centennial",

  //membership
  membership: "https://member.kleer.com/?slug=DN7G",

  // Sunbit
  sunbitUrl: "https://www.dentistincentennial.com/patient-portal",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-centennial?utm_source=practice&utm_medium=email&m=65978",


  // Analytics
  clarityProjectId: "qxtfof6tvo",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistincentennial",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistincentennial",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistincentennial",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistincentennial.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinCentennial",
    instagram: "https://www.instagram.com/dentist_centennial/",
    twitter: "https://x.com/Dent_Centennial",
    linkedin: "https://www.linkedin.com/company/dentist-in-centennial/",
    youtube: "https://www.youtube.com/@DentistinCentennial",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 11,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 9,
      AppointmentTypeNum: 7
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 6
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 3
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "17207092902",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

